import React from "react";
import { Bar } from "react-chartjs-2";
import { chartHelpers } from "./Charts";
import dataBarChart from "./data/barchart.json";

export class BarChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dataChart: (this.props.data||dataBarChart)
    };
  }

  componentDidMount() {
    this.setState({
      dataChart: chartHelpers.mergeColorsIntoData(dataBarChart),
      isLoaded: true
    });
  }

  optionsBar() {
    return {
      responsive: true,
      scales: {
        xAxes: [
          {
            barPercentage: 0.4,
            categoryPercentage: 0.6
          }
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: false
            }
          }
        ]
      },
      legend: {
        display: false
      }
    };
  }

  render() {
    var { dataChart,isLoaded } = this.state;
    return (
      (isLoaded ?
      <Bar
        data={dataChart}
        options={this.optionsBar()}
      />:'')
    );
  }
}

export default BarChart;
